import { Trash2 } from 'lucide-react';

const RoleMemberRow = ({ member, index, currentUserRole, onDelete }) => {
  const canDelete =
    currentUserRole === 'admin' ||
    (currentUserRole === 'subadmin' && member.role !== 'admin' && member.role !== 'subadmin');

  return (
    <div className="flex items-center justify-between py-1 group hover:bg-slate-50/80 transition-all duration-200">
      <div className="w-16 sm:w-20 px-6 py-3.5 text-sm text-slate-400 font-normal whitespace-nowrap">
        {index + 1}
      </div>
      <div className="flex-1 min-w-[200px] px-6 py-3.5">
        <div className="flex items-center gap-3">
          <div className="w-8 h-8 rounded-full bg-teal-50 text-[#067978] flex items-center justify-center overflow-hidden font-normal text-sm flex-shrink-0">
            {member.email ? member.email.charAt(0).toUpperCase() : 'U'}
          </div>
          <div className="min-w-0 truncate">
            <div className="font-normal text-slate-800 text-sm truncate" title={member.email}>
              {member.email}
            </div>
          </div>
        </div>
      </div>
      <div className="w-32 sm:w-36 px-6 py-3.5">
        {member.role === 'admin' ? (
          <span className="px-2.5 py-0.5 text-xs font-normal rounded-full uppercase tracking-wider inline-block bg-purple-50 text-purple-600">
            ADMIN
          </span>
        ) : member.role === 'subadmin' ? (
          <span className="px-2.5 py-0.5 text-xs font-normal rounded-full uppercase tracking-wider inline-block bg-indigo-50 text-indigo-600">
            SUB-ADMIN
          </span>
        ) : member.role === 'bookings' ? (
          <span className="px-2.5 py-0.5 text-xs font-normal rounded-full uppercase tracking-wider inline-block bg-sky-50 text-sky-600">
            BOOKINGS
          </span>
        ) : (
          <span className="px-2.5 py-0.5 text-xs font-normal rounded-full uppercase tracking-wider inline-block bg-amber-50 text-amber-600">
            OPERATIONS
          </span>
        )}
      </div>
      <div className="w-36 sm:w-44 px-6 py-3.5 text-sm font-normal text-slate-700 font-mono truncate">
        {member.phone_number || 'N/A'}
      </div>
      <div className="w-28 sm:w-32 px-6 py-3.5 flex justify-center">
        <span className="inline-flex items-center gap-1.5 text-sm font-normal text-emerald-600">
          <span className="w-1.5 h-1.5 rounded-full bg-emerald-500"></span>
          Active
        </span>
      </div>
      <div className="w-28 sm:w-32 px-4 py-3.5 flex items-center justify-center">
        {canDelete ? (
          <button
            onClick={() => onDelete(member._id, member.role, member.email)}
            className="p-2 text-rose-500 hover:bg-rose-50 rounded-xl transition-all cursor-pointer"
            title="Remove team member"
          >
            <Trash2 size={16} />
          </button>
        ) : (
          <span className="text-xs text-slate-300 font-medium italic">Restricted</span>
        )}
      </div>
    </div>
  );
};

export default RoleMemberRow;
